/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import Input from './Input';

const InputLoading = (props) => {
  return <Input {...props} placeholder="Loading..." disabled={true} />;
};

export default React.memo(InputLoading, (prev, next) => prev == next);
